import { render, staticRenderFns } from "./LectureEdit.vue?vue&type=template&id=91a454dc&"
import script from "./LectureEdit.vue?vue&type=script&lang=ts&"
export * from "./LectureEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports